import { GameStatues, GameTeams, IGame, IGameAttendances, IPlayerGame, IUserPlayer } from "@grassrootly/api";
import moment from 'moment';

export function isAttending(game: IGame, player: IUserPlayer): boolean {
  return !!game.attendees.find((a) => a.player_id == player.id && a.attended);
}

export function hasChoosenAttendance(game: IGame, player: IUserPlayer): boolean {
  return !!game.attendees.find((a) => a.player_id == player.id && a.attended != null);
}

export function isFinished(game: IGame | IPlayerGame): boolean {
  if (!game) {
    return false;
  }
  if ((game as IGame).status) {
    return [GameStatues.FINISHED, GameStatues.FINALIZED].indexOf((game as IGame).status) > -1;
  }
  if ((game as IPlayerGame).game_status) {
    return [GameStatues.FINISHED, GameStatues.FINALIZED].indexOf((game as IPlayerGame).game_status) > -1;
  }
  return false;
}

export function isPlayerAttended(game: IPlayerGame): boolean {
  return game.player_attended !== false && game.player_attended !== null;
}

export function isInStatus(game: IGame | IPlayerGame, status: GameStatues): boolean {
  if (!game) {
    return false;
  }
  if ((game as IGame).status) {
    return (game as IGame).status === status;
  }
  if ((game as IPlayerGame).game_status) {
    return (game as IPlayerGame).game_status === status;
  }
  return false;
}

export function isScheduledOrConfirmed(game: IGame | IPlayerGame): boolean {
  const statuses = [GameStatues.SCHEDULED, GameStatues.CONFIRMED];
  if (!game) {
    return false;
  }
  if ((game as IGame).status) {
    return statuses.indexOf((game as IGame).status) !== -1;
  }
  if ((game as IPlayerGame).game_status) {
    return statuses.indexOf((game as IPlayerGame).game_status) !== -1;
  }
  return false;
}

export function getGameMVP(attendees: IGameAttendances[]): IGameAttendances {
  // todo: better sorting
  return attendees.filter((a) => a.attended).sort((a, b) =>{ 
    let diff = b.rating - a.rating;
    if(diff!=0) return diff;

    return b.points_earned - a.points_earned;

    } )[0];
}

export function hasScoredOrAssisted(player: IGameAttendances): boolean {
  return !!player.assists_made || !!player.goals_scored;
}

export function formatDateTime(datetime: string | null): string {
  return moment(datetime).format('DD.MM.YYYY. HH:mm');
}

export { GameTeams };